import React from 'react'


export default function Index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-title">
        Directions
      </div>
      <div className="assessment1-content">
        Next up, do you remember your guests' names?
      </div>
      <div className="assessment1-wrap">
        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
